import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1544621189/src/WedInviteWebsite/app/about/aboutUsContent.tsx");
